import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { AttributeItemInterface } from '@/components/CustomDialog/AddProductAttributesDialog/AddProductAttributesDialog';
import { ProductVariant } from '@/models/ProductVariant';
import { Attribute } from '@/models/Attribute';

@Component<AddProductAttributesAttributesStep>({})
export default class AddProductAttributesAttributesStep extends Vue {
  // #region @PropSyncs

  @PropSync('selectedAttributesSync')
  protected selectedAttributes!: AttributeItemInterface[];

  // #endregion

  // #region @Props

  @Prop({ default: () => [] })
  protected attributes!: Attribute[];

  @Prop({ default: () => [] })
  protected productAttributeSummary!: any[];

  @Prop({ default: '1' })
  protected step!: string;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props
  // #endregion

  // #region Lifecycle Hooks / Init

  // /**
  //  * if both the attribute and its option or value is known
  //  * the 'value' as it were can be the result of a select
  //  * (attributeOption) or normal input (Attribute)
  //  *
  //  * @readonly
  //  * @memberof AddProductAttributesDialog
  //  */
  // get attributeAndAttributeValueSet()
  // {
  //   return (this.selectedNewAttributeId as string) &&
  //   (
  //     (this.selectedAttributeOption as AttributeOption)
  //       || ( (this.attribute as Attribute)
  //         && (this.attribute as Attribute).value )
  //   );
  // }

  // #endregion

  // #region Handlers

  protected onCloseButtonClick(): void {
    this.$emit('close');
  }

  protected onNextButtonClick(): void {
    this.$emit('next');
  }

  // #endregion

  // #region Helpers
  // /**
  //  * called when new attribute id is changed
  //  * this.attributeAndAttributeValueSet can return true with the value related to the the last attribute id
  //  * thus reset explicitly the values
  //  *
  //  * @private
  //  * @memberof AddProductAttributesDialog
  //  */
  // private resetAttributeOptionOrValue() {
  //   this.attribute = null;
  //   this.selectedAttributeOption = null;
  // }

  protected toggleAddAttributeOption(attribute: string, option: string) {
    if (this.isOptionSelected(attribute, option)) {
      const clearedAttributes = this.selectedAttributes.filter((currentAttribute: AttributeItemInterface) => {
        return (currentAttribute.attribute !== attribute) || (currentAttribute.attribute === attribute && currentAttribute.option !== option);
      });

      this.$set(this, 'selectedAttributes', clearedAttributes);
    } else {
      const attributeFilter: AttributeItemInterface = { attribute, option };
      this.selectedAttributes.push(attributeFilter);
    }
  }

  protected isOptionSelected(attribute: string, option: string) {
    return this.selectedAttributes.some((currentAttribute: AttributeItemInterface) => {
      return currentAttribute.attribute === attribute && currentAttribute.option === option;
    });
  }

  // #endregion

  // #region Async methods
  // #endregion

  // #region Getters & Setters

  protected get optionIdsCurrentlyOnProduct(): string[] {
    if (!this.productAttributeSummary) { return []; }

    let optionIds: string[] = [];

    this.productAttributeSummary.forEach((attribute) => {
      if (! attribute.values ) { return; }

      const attributeOptionIds: string[] = attribute.values.map((value: any) => value.option.id || '');

      optionIds = [...optionIds, ...attributeOptionIds];
    });

    return optionIds;
  }

  // #endregion

  // #region @Watchers
  // #endregion
}

// #region Enums
// #endregion

// #region Types
// #endregion

// #region Interfaces
// #endregion
